import React from "react";
import {ReactComponent as ClockIconSmall} from "../../../../../images/state/clock_24.svg";
import {ReactComponent as DeclineIconSmall} from "../../../../../images/state/do_disturb_24.svg";
import {ReactComponent as AcceptIconSmall} from "../../../../../images/state/check_circle_24.svg";
import {ReactComponent as AddIconSmall} from "../../../../../images/state/add_circle_24.svg";
import {ReactComponent as EditIconSmall} from "../../../../../images/state/edit_24.svg";

export const SmallStateIcon = (stateid, classname) => {
  switch(stateid) {
    case 0:
      return <ClockIconSmall className={classname}/>;
    case 1:
      return <AcceptIconSmall className={classname}/>;
    case -1:
      return <DeclineIconSmall className={classname}/>;
    default:
      return <ClockIconSmall className={classname}/>;
  }
};

export const SmallTypeIcon = (typeid, classname) => {
  switch(typeid) {
    case 0:
      return <AddIconSmall className={classname}/>;
    case 1:
      return <EditIconSmall className={classname}/>;
    default:
      return <AddIconSmall className={classname}/>;
  }
};

export const StateTextColor = stateid => {
  switch(stateid) {
    case 0:
      return "#007FBD";
    case 1:
      return "#85C446";
    case -1:
      return "#F15454";
    default:
      return "#000000";
  }
};

export const TypeLabelBackground = typeid => {
  switch(typeid) {
    case 0:
      return "rgba(48,73,103,0.7)";
    case 1:
      return "rgba(119,136,153,0.7)";
    default:
      return "rgba(0,0,0,0.7)";
  }
};
